"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkButton = void 0;
const React = __importStar(require("react"));
const button_styled_1 = require("./button.styled");
const constants_1 = require("./constants");
const withDefaults = (props) => (Object.assign(Object.assign({}, props), { label: props.label || '', className: props.className || '', iconBefore: props.iconBefore || '', iconAfter: props.iconAfter || '', disabled: props.disabled || false }));
const buttonClasses = (styleProps) => {
    const { disabled, className } = styleProps;
    const classes = [
        'merlin-button'
    ];
    if (disabled)
        classes.push('merlin-button--disabled');
    if (className)
        classes.push(className);
    return classes.join(' ');
};
const LinkButton = (props) => {
    const { label = '', disabled, id, iconBefore, children, iconAfter, buttonType, } = props;
    const external = props.to.indexOf('http') === 0;
    const classes = buttonClasses(withDefaults(props));
    const buttonTheme = buttonType ? constants_1.presetThemes[buttonType] : constants_1.presetThemes.Neutral;
    const handler = disabled ?
        (e) => e.preventDefault() :
        undefined;
    const LinkComponent = external ? button_styled_1.StyledAnchorButton : button_styled_1.StyledLinkButton;
    const attrs = Object.assign({}, props);
    if (external) {
        attrs.href = attrs.to;
        delete attrs.to;
    }
    return (React.createElement(LinkComponent, Object.assign({}, buttonTheme, attrs, (external && { target: '_blank' }), { id: id, "aria-label": label, className: classes, onClick: handler }),
        React.createElement("div", { className: `merlin-button__content` },
            iconBefore && React.createElement("span", { className: "merlin-button__icon button__icon--before" }, iconBefore),
            children,
            iconAfter && React.createElement("span", { className: "merlin-button__icon button__icon--after" }, iconAfter))));
};
exports.LinkButton = LinkButton;
//# sourceMappingURL=LinkButton.js.map